import React from "react";
import { transformVar } from "@quarkly/atomize";
import { createGlobalStyle } from "styled-components";

const pageStyles = {
    "404": {},
    "index": {
        "overflow-x": "hidden",
        "overflow-y": "hidden",
        "background": "rgba(0, 0, 0, 0) url(https://uploads.quarkly.io/63a735459faa0f00208ed884/images/%D1%87%D0%B0%D0%BA%D1%80%D0%B0%D0%BB%D1%8D%D0%BD%D0%B4%D1%84%D1%83%D0%BB%D0%B1%D1%8D%D0%BA1.png?v=2023-01-06T02:55:16.434Z) center/cover no-repeat scroll padding-box"
    }
};

const PageStyles = createGlobalStyle`
    body {
        ${({ styles }) =>
            Object.entries(styles || {}).map(
                ([prop, value]) => `${prop}: ${transformVar(prop, value)};`
            )}
    }
`;
export const GlobalQuarklyPageStyles = ({ pageUrl }) => <PageStyles styles={pageStyles[pageUrl]} />
